import store from '#/store';

export default function addWorkspaceRequiredRuleToRouter(router) {
  router.beforeEach((to, from, next) => {
    // this rule only applies if the route record contains the "requiresWorkspace" flag
    const workspaceIsRequired = to.matched.some((record) => record.meta.requiresWorkspace);
    if (!workspaceIsRequired) {
      // if workspace isn't required, bail from this rule immediately after calling next()
      next();
      return;
    }
    // if we made it this far we need a workspace id in the route params.
    let { workspaceId } = to.params;

    if (workspaceId) {
      // check if workspace id is present in workspace list
      if (!store.getters.accountById(workspaceId)) {
        store.commit('setErrorOnLoad', 'Workspace Not Found'); // Throw error in loadError variable
      }

      // TODO: REMOVE ROUTE PARAMS in favor of query param always
      store.commit('setRouteWorkspaceId', workspaceId);
      next();
      return;
    }

    // check route query params for workspace
    workspaceId = to.query.workspace;
    if (workspaceId) {
      store.commit('setRouteWorkspaceId', workspaceId);
      next();
      return;
    }

    // check if we have an active workspace in the store
    const { activeWorkspaceId } = store.getters;
    if (activeWorkspaceId) {
      const { query } = to;
      query.workspace = activeWorkspaceId;
      next({ path: to.path, query });
      return;
    }

    // check if we have a history of "last active" workspace.
    const { lastActiveWorkspaceId } = store.getters;
    if (lastActiveWorkspaceId) {
      const { query } = to;
      query.workspace = lastActiveWorkspaceId;
      next({ path: to.path, query });
      return;
    }

    // if we still dont have a workspace id we need to force show the selection modal window so the user can pick
    router.app.$bvModal.show('workspace-project-modal');
    next();
  });
}
